import { api } from './api';

export const recipesService = {
  // Get all recipes (optionally filtered by category)
  getAll: async (category = null) => {
    const params = category && category !== 'all' ? { category } : {};
    const { data } = await api.get('/api/recipes', { params });
    return data;
  },

  // Get recipe by ID
  getById: async (id) => {
    const { data } = await api.get(`/api/recipes/${id}`);
    return data;
  },

  // Delete recipe
  delete: async (id) => {
    const { data } = await api.delete(`/api/recipes/${id}`);
    return data;
  },

  // Save recipe from OCR
  saveFromOCR: async (file, title, content, confidence, method) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('content', content);
    if (confidence) formData.append('confidence', confidence.toString());
    if (method) formData.append('method', method);

    const { data } = await api.post('/api/recipes/save-ocr', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return data;
  }
};
